<template>
  <div class="content">
    <!-- 视频背景 -->
    <video class="video-bg" autoplay muted loop playsinline>
      <source src="https://agamaship.com/agamashipdiv.mp4" type="video/mp4" />
    </video>
    
    <!-- 左上角Logo -->
    <div class="top-left-logo">
      <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
    </div>
    
    <div class="login-container">
      <div class="login-header">
        <div class="logo-container">
          <div class="logo">
            <img src="@/assets/logo.png" alt="地球联邦军Logo" class="logo-img" />
          </div>
        </div>
        <h1 class="system-title">地球联邦军</h1>
        <h2 class="system-subtitle">EARTH FEDERATION FORCE</h2>
        <div class="divider"></div>
      </div>
      
      <div class="login-form">
        <div class="input-group">
          <label for="username">驾驶员ID</label>
          <div class="input-wrapper">
            <input 
              type="text" 
              id="username" 
              v-model="username" 
              placeholder="请输入驾驶员ID"
              class="form-input"
            />
            <div class="input-line"></div>
          </div>
        </div>
        
        <div class="input-group">
          <label for="password">访问密钥</label>
          <div class="input-wrapper">
            <input 
              type="password" 
              id="password" 
              v-model="password" 
              placeholder="请输入访问密钥"
              class="form-input"
            />
            <div class="input-line"></div>
          </div>
        </div>
        
        <button @click="login" class="login-btn">
          <span>系统验证</span>
          <div class="btn-glow"></div>
        </button>
        
        <div class="login-options">
          <span class="forgot-pwd" @click="showForgotPassword">忘记密钥(联系技术部)</span>
          <span class="register-link" @click="navigateToRegister">新兵注册</span>
        </div>
      </div>
      
      <div class="tech-decoration">
        <div class="tech-circle tech-circle-1"></div>
        <div class="tech-circle tech-circle-2"></div>
        <div class="tech-circle tech-circle-3"></div>
      </div>
    </div>
    
    <div class="footer">
      <p>地球联邦军 © 2023 版权所有</p>
      <p>技术支持：阿纳海姆电子公司 | 粤ICP备2026000017号-1 | 中山祖艺模玩</p>
    </div>
  </div>
</template>

<script>
import { clearAuthSession, notifyAuthenticated, showToast, navigateTo, setStorageSync } from '@/utils/uni-app'
import api from '@/api'

export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: ''
    };
  },
  methods: {
    login() {
      clearAuthSession()
      // 登录逻辑，连接到登录API
      console.log('Login:', this.username, this.password);
      
      api.formPost('/liner/login_web', {
        username: this.username,
        password: this.password
      })
        .then(res => {
          let data = res // 响应拦截器已经返回了response.data
          if(data.code == 200){
            console.log(data.data.username)
            console.log(data.data.token)
            // 如果API返回的username为空，使用登录时输入的用户名
            const savedUsername = data.data.username || this.username
            setStorageSync('username', savedUsername)
            setStorageSync('token', data.data.token)
            notifyAuthenticated()
            showToast({
              title: "系统验证成功",
              duration: 1500,
              icon: "success"
            });
            setTimeout(() => {
              navigateTo('/')
            }, 1500)
          } else {
            showToast({
              title: data.msg,
              duration: 2000,
              icon: "error"
            });
          }
        })
        .catch(err => {
          console.error('登录错误:', err)
          showToast({
            title: "系统验证失败",
            duration: 2000,
            icon: "error"
          });
        })
    },
    navigateToRegister() {
      navigateTo('/register') // 跳转到注册页面
    },
    showForgotPassword() {
      showToast({
        title: "请联系技术部获取访问密钥",
        duration: 3000,
        icon: "none"
      });
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.content {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #000;
  color: #fff;
  font-family: 'Arial', sans-serif;
}

/* 视频背景 */
.video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

/* 左上角Logo */
.top-left-logo {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 10px;
}

.top-left-logo .logo-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

/* 背景动画效果 */
.bg-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.grid-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 255, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: grid-move 20s linear infinite;
}

@keyframes grid-move {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.element {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 255, 255, 0.3) 0%, rgba(0, 255, 255, 0) 70%);
}

.element-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: 10%;
  animation: float 15s infinite ease-in-out;
}

.element-2 {
  width: 200px;
  height: 200px;
  top: 60%;
  right: 15%;
  animation: float 12s infinite ease-in-out reverse;
}

.element-3 {
  width: 150px;
  height: 150px;
  bottom: 20%;
  left: 30%;
  animation: float 18s infinite ease-in-out;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  25% { transform: translate(30px, -50px) scale(1.1); }
  50% { transform: translate(-20px, 30px) scale(0.9); }
  75% { transform: translate(40px, 20px) scale(1.05); }
}

/* 登录容器 */
.login-container {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 20px;
}

/* 登录头部 */
.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-container {
  margin-bottom: 20px;
}

.logo {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border: 2px solid #00ffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
  overflow: hidden;
}

.logo-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.system-title {
  font-size: 32px;
  font-weight: bold;
  margin: 10px 0 5px;
  color: #fff;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.7);
  letter-spacing: 2px;
}

.system-subtitle {
  font-size: 18px;
  margin: 0 0 20px;
  color: #00ffff;
  letter-spacing: 3px;
}

.divider {
  width: 80%;
  height: 1px;
  margin: 20px auto;
  background: linear-gradient(90deg, rgba(0, 255, 255, 0) 0%, rgba(0, 255, 255, 0.8) 50%, rgba(0, 255, 255, 0) 100%);
}

.login-title {
  font-size: 18px;
  margin: 20px 0;
  color: #a0d0ff;
  letter-spacing: 1px;
}

/* 登录表单 */
.login-form {
  width: 100%;
  max-width: 400px;
  background: rgba(10, 20, 40, 0.85);
  border: 1px solid rgba(0, 255, 255, 0.3);
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5), inset 0 0 20px rgba(0, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.input-group {
  margin-bottom: 25px;
}

.input-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #00ffff;
  letter-spacing: 1px;
}

.input-wrapper {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 12px 15px;
  background: rgba(0, 20, 40, 0.7);
  border: 1px solid rgba(0, 255, 255, 0.3);
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  outline: none;
  transition: all 0.3s;
}

.form-input:focus {
  border-color: #00ffff;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.3);
}

.input-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #00ffff;
  transition: width 0.3s;
}

.form-input:focus + .input-line {
  width: 100%;
}

.login-btn {
  position: relative;
  width: 100%;
  padding: 12px;
  margin-top: 20px;
  background: linear-gradient(90deg, #0080ff 0%, #00ffff 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 255, 255, 0.4);
}

.btn-glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.login-btn:hover .btn-glow {
  left: 100%;
}

.login-options {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 14px;
}

.forgot-pwd, .register-link {
  color: #a0d0ff;
  cursor: pointer;
  transition: color 0.3s;
}

.forgot-pwd:hover, .register-link:hover {
  color: #00ffff;
}

/* 技术装饰 */
.tech-decoration {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  pointer-events: none;
}

.tech-circle {
  position: absolute;
  border: 1px solid rgba(0, 255, 255, 0.2);
  border-radius: 50%;
}

.tech-circle-1 {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -100px;
  animation: rotate 30s linear infinite;
}

.tech-circle-2 {
  width: 200px;
  height: 200px;
  bottom: -50px;
  left: -50px;
  animation: rotate 25s linear infinite reverse;
}

.tech-circle-3 {
  width: 150px;
  height: 150px;
  top: 50%;
  right: 10%;
  animation: rotate 20s linear infinite;
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 页脚 */
.footer {
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  padding: 20px 0;
  flex-shrink: 0;
}

.footer p {
  margin: 5px 0;
}
</style>
